import React from 'react';

export default function PreFooterCallout() {
  return null;
}
